import React from "react";
import _post from "../Functions/Post"
import stylesASAP from "./stylesASAP"
import { ArrowBackCircle } from 'react-ionicons'
import SignaturePad from 'react-signature-pad-wrapper'

export default class Signature extends React.Component {

    constructor() {
        super();
        this.state = {
            data: ""
        }
        this.sign = React.createRef();
    }

    clear = () => {
        this.sign.current.clear();
    }

    print = () => {
        window.print();
    }

    save = () => {
        this.setState({ data: this.sign.current.toDataURL() })
    }

    show = async () => {
        await this.sign.current.fromDataURL(this.state.data);
    }

    render() {
        console.log(this.state.data)
        return (
            <div>

                <div className="pt-3 row">
                    <div className="col">
                        <ArrowBackCircle className=" btn" onClick={() => this.props.history.push('/items')} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <div className="col">
                        <h1 className=" text-center"> Signature</h1>
                    </div>
                    <div className="col d-flex flex-row-reverse">

                        <div className="btn" style={stylesASAP.wideButton} onClick={this.save}>Save</div>
                        <div className="btn " style={stylesASAP.clearButton} onClick={this.clear}>Clear</div>
                        <div className="btn " style={stylesASAP.clearButton} onClick={this.show}>Show</div>
                    </div>
                    <hr />
                </div>
                <div className="text-center mt-1 " >
                    {/*  <SignatureComponent className="text-center mt-5 border" style={stylesASAP.signature}> </SignatureComponent>*/}
                    <SignaturePad className="text-center border" style={stylesASAP.signature} ref={this.sign} options={{ minWidth: 3, maxWidth: 3, penColor: '#00bfff' }} />
                </div>

            </div>
        )
    }
}